// @ts-nocheck
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
import copy from "copy-to-clipboard";
import { Cell, Dialog } from "react-vant";
import "./index.css";
import { Button } from "antd";
import { Toast } from "antd-mobile";
import { useState } from "react";
import { imageConfig } from "../../../../config/config";

export default function CenterPage({ coinList }) {
  const navigate = useNavigate();
  const lan = localStorage.getItem("i18n");
  const c2ctxStatus = localStorage.getItem("c2ctxStatus");
  const c2cczStatus = localStorage.getItem("c2cczStatus");

  const { t: translate } = useTranslation();
  const companySkin = localStorage.getItem("companySkin");

  const getNode = () => {
    const nodes = [];
    for (let i = 0; i < coinList.length; i++) {
      const data = coinList[i];
      const node = (
        <div
          key={data?.id}
          className="bg-neutral-800 rounded-lg shadow-card border border-neutral-700 hover:border-primary transition-colors cursor-pointer overflow-hidden"
          onClick={() => {
            navigate(`/pledgeConfirm/${data?.id}`);
          }}
        >
          <div className="p-4">
            <div className="flex items-center justify-between mb-3 border-b border-neutral-700 pb-3">
              <div className="flex items-center">
                <div className="relative w-8 h-8 mr-3 overflow-hidden rounded-full bg-neutral-700 flex items-center justify-center">
                  <img
                    src={imageConfig.baseImageUrl + data?.img}
                    className="w-full h-full object-contain"
                    alt={data.name}
                  />
                </div>
                <span className="text-lg font-medium text-neutral-100">{`${data.name.toUpperCase()}${
                  data.czline ? ` (${data.czline.toUpperCase()})` : ""
                }`}</span>
              </div>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-primary text-base font-medium">
                {translate(getText("還款"))}
              </span>
              <i className="fas fa-chevron-right text-neutral-400"></i>
            </div>
          </div>
        </div>
      );
      nodes.push(node);
    }
    return nodes;
  };

  return (
    <div className="w-full bg-neutral-900 text-neutral-100">
      <div className="px-4 py-4">
        <div className="mb-6">
          <div className="bg-neutral-800 rounded-lg p-4 border border-neutral-700">
            <p className="text-sm text-neutral-300 m-0">
              {translate(
                getText(
                  "請如實填寫實際轉賬金額，否則可能導致系統審核無法通過，影響還款進度。"
                )
              )}
            </p>
          </div>
        </div>
        <p className="text-xl font-bold text-center mb-6 text-neutral-100">
          {translate(getText("請選擇以下還款通道"))}
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {getNode()}
        </div>
      </div>
    </div>
  );
}
